import { render, staticRenderFns } from "./RoutesTree.vue?vue&type=template&id=1bfdb739&scoped=true&"
import script from "./RoutesTree.vue?vue&type=script&lang=js&"
export * from "./RoutesTree.vue?vue&type=script&lang=js&"
import style0 from "./RoutesTree.vue?vue&type=style&index=0&id=1bfdb739&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfdb739",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/akryum/Projects/vue-devtools/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bfdb739')) {
      api.createRecord('1bfdb739', component.options)
    } else {
      api.reload('1bfdb739', component.options)
    }
    module.hot.accept("./RoutesTree.vue?vue&type=template&id=1bfdb739&scoped=true&", function () {
      api.rerender('1bfdb739', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@vue-devtools/app-frontend/src/views/routes/RoutesTree.vue"
export default component.exports